import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators/catchError';
import { CoreTask } from './core-task';
import { Subject } from 'rxjs/Subject';
import { HttpError } from 'app/errors';
import { Workprocess } from './workprocess/workprocess';

@Injectable()
export class CoreTaskService {
  private coreTaskRetrievalErrorBase = new Subject<boolean>();
  public coreTaskRetrievalError$ = this.coreTaskRetrievalErrorBase.asObservable();

  private closeCoreTaskErrorBase = new Subject<boolean>();
  public closeCoreTaskError$ = this.closeCoreTaskErrorBase.asObservable();

  constructor(private http: HttpClient) { }

  public getCoreTaskByStudentCreboId(id: string) {
    return this.http.get<CoreTask>(`/kerntaken/${id}`)
      .map(data => {
        data.werkproces.forEach((wp, i) => {
          data.werkproces[i].done = this.workprocessCompleted(wp);
        });
        return data;
      })
      .pipe(catchError(error => {
        this.coreTaskRetrievalErrorBase.next(false);
        throw new HttpError(`Error retrieving core task: ${id}`);
      }));
  }

  public getCoreTaskIsVolledigOndertekend(id: string) {
    return this.http.get<boolean>(`/kerntaken/${id}/isvolledigondertekend`, {}).pipe(catchError(error => {
      this.closeCoreTaskErrorBase.next(false);
      throw new HttpError(`Error retrieving isvolledigondertekend core task: ${id}`);
    }));
  }

  private workprocessCompleted(wp: Workprocess) {
    if (wp.resultaatWerkproces === null) {
      return false;
    }

    if (wp.resultaatWerkproces === '') {
      return false;
    }

    if (wp.resultaatWerkproces !== 'Ja') {
      if (wp.opmerkingen === null) {
        return false;
      }

      if (wp.opmerkingen === '') {
        return false;
      }
    }

    return true;
  }

  public closeCoreTask(id: string) {
    return this.http.post<boolean>(`/kerntaken/${id}/gereed`, {}).pipe(catchError(error => {
      this.closeCoreTaskErrorBase.next(false);
      throw new HttpError(`Error retrieving core task: ${id}`);
    }));
  }
}



// WEBPACK FOOTER //
// ./src/app/examination/core-task.service.ts